cv.iframeTrigger = function(){
  var args = Array.prototype.slice.call(arguments);
  vent.trigger.apply(vent, args);
};